import { ID_WEBCHAT_OUTPUT } from '../constants';

/**
 * Export function which provides Container for Webchat Content
 * @param containerName
 */
export const renderContainerForWebchatContent = (containerName: string, parentContainerId?: string) => {

    const chatContent = document.getElementById(parentContainerId ? parentContainerId : ID_WEBCHAT_OUTPUT);
    // const chatContentWrapperId = containerName + new Date().getTime();
    // changed to random, because more than one element is rendered in one millisecond
    const chatContentWrapperId = containerName + Math.random().toString().substring(2);

    chatContent.insertAdjacentHTML('beforeend', '<div id="' + chatContentWrapperId + '"> </div>');

    return chatContentWrapperId;
};
